// this file is generated by update_shopify_store_data.py at 2026-11-03 20:14:40.637813
var courses = [
    {
        "course_id": "27B0A603-F451-F011-999A-005056A7F31D",
        "course_version": 2,
        "name": "Essentials of Pediatric Acute Care Orientation",
        "course_type": 32,
        "author_information": "",
        "description": "Developed in collaboration with Pediatric Learning Solutions PACO Advisory Committee and subject matter experts, Essentials of Pediatric Acute Care Orientation (EPACO) uniquely bridges the knowledge gap between what clinicians learn in school and what is expected of them in treating hospitalized children. These CE-approved online modules ensure all orientees receive evidence-based, standardized education with content that is continually reviewed and updated. This comprehensive program engages learners with attractive graphics, illustrations, videos, and photos. Case scenarios and practice activities enhance knowledge transfer and knowledge retention.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "EC8BBAFB-2E51-F011-9998-005056A730AF",
                "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "D504F573-967C-F111-99B5-005056A773F1",
                "course_version": 1,
                "name": "PLS - EPACO: Modalities of Pediatric Nutrition",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Nutrition is a critical component of pediatric well-being at all stages of development and may be affected by both acute and chronic illnesses.\r\n\r\nFood and drink consumed orally is the primary way humans acquire nutrition. While a balanced diet is ideal, there are times when nutrition must be achieved through alternative methods. This course provides an overview of multiple ways to achieve adequate pediatric nutrition.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify when traditional methods of nutrition are not appropriate and the options for alternative delivery of nutrients.</li>\r\n    <li>Describe feeding products that are tailored to the needs of different patient populations.&nbsp;</li>\r\n    <li>Identify routes of administration and explain how to safely initiate, administer, monitor and maintain each type of feeding.&nbsp;</li>\r\n    <li>Discuss indications for oral supplementation, enteral nutrition and parenteral nutrition.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FF3C3B5F-D91C-E811-8740-005056B12710",
                "course_version": 4,
                "name": "PLS - EPACO: Age-Specific Care for Adolescents",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Sensitive Content Warning\r\nThis course addresses sensitive topics, including suicide and eating disorders. Some content may be distressing or triggering for learners. Please take care of your emotional well-being while engaging with this material. This course provides an overview of age-specific growth and development for adolescents ages 13 through 19. It addresses the physical, cognitive and psychosocial needs of the patient and family. By understanding and incorporating this knowledge into daily practice, you will be more effective in providing competent care to adolescents.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the physiologic and developmental characteristics of adolescents.&nbsp;</li>\r\n    <li>Discuss developmental considerations and age-specific care of adolescents.&nbsp;</li>\r\n    <li>Describe the adolescent's age-specific needs applied to your daily practice.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "055592C7-7823-E811-BEE8-005056B1633E",
                "course_version": 4,
                "name": "PLS - EPACO: Age-Specific Care for Infants",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course examines age-specific growth and development in infants ages 29 days to 12 months, with a focus on physical, cognitive, communication and psychosocial needs of the infant and family. Integrating this knowledge into clinical practice enhances the ability to provide competent, high-quality infant care.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Explain how to provide individualized care based on the developmental needs of the patient and family.&nbsp;</li>\r\n    <li>State major developmental considerations and age-specific care for infants 29 days to 12 months old.&nbsp;</li>\r\n    <li>Incorporate the knowledge of an infant's developmental needs into practice.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E1564EDE-7823-E811-BEE8-005056B1633E",
                "course_version": 4,
                "name": "PLS - EPACO: Age-Specific Care for Newborns",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development in newborns from birth to 28 days, including high-risk neonates. It examines the physiologic, cognitive and psychosocial needs of infants and their families. Applying this knowledge to daily practice supports the delivery of safe, competent and effective neonatal care.\r\n\r\nThis course provides a high-level overview of common assessment findings and age-specific considerations for newborn care. For a more detailed review of newborn assessment findings, see Pediatric Learning Solutions\u2019 *Comprehensive Assessment of the Neonate course.* Note: This module may not be currently available in your organization.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss developmental considerations and age-specific care of the newborn.&nbsp;</li>\r\n    <li>Identify the physiological and developmental characteristics of the neonate, including high-risk neonates.&nbsp;</li>\r\n    <li>Describe the newborn&rsquo;s age-specific needs.&nbsp;</li>\r\n    <li>Identify normal assessment findings and appropriate interventions.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "8369A9EE-7823-E811-BEE8-005056B1633E",
                "course_version": 4,
                "name": "PLS - EPACO: Age-Specific Care for Preschoolers",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development for preschoolers from 3 through 5 years of age. The physical, cognitive and psychosocial needs of the patient and family are discussed. By understanding and incorporating this knowledge into your daily practice, you will be more effective in providing competent care to preschoolers.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to: </p>\r\n<ul>\r\n    <li>\r\n    Identify expected developmental and physiologic characteristics of the preschooler across physical, cognitive, emotional, and social domains.</li>\r\n    <li>Apply age-specific developmental and psychological principles to assessment, communication, and daily clinical care of preschool-aged children.</li>\r\n    <li>Recognize age-appropriate needs of preschoolers to support safe, family-centered, and developmentally appropriate care.&nbsp;<br />\r\n    <div>&nbsp;</div>\r\n    &nbsp;    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.25 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "61D4A402-7923-E811-BEE8-005056B1633E",
                "course_version": 4,
                "name": "PLS - EPACO: Age-Specific Care for School-Age Children",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development for school-age children from 6 through 12 years of age. The physical, cognitive, and psychosocial needs of the patient and family are discussed. By understanding and incorporating this knowledge into your daily practice, the clinician will be more effective in providing competent care to school-age children.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify expected developmental and physiological characteristics of the school-age child across physical, cognitive, emotional, and social domains.</li>\r\n    <li>Apply age-specific developmental and psychological principles to assessment, communication, and daily clinical care of school-aged children.</li>\r\n    <li>Recognize the age-appropriate needs of school-age children to support safe, family-centered, and developmentally appropriate care.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0621A911-7923-E811-BEE8-005056B1633E",
                "course_version": 4,
                "name": "PLS - EPACO: Age-Specific Care for Toddlers",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development in toddlers. A child is considered a toddler from age 12 to 36 months. This course examines the physical, cognitive and psychosocial needs of both the child and the family. Applying this knowledge to daily practice supports the delivery of competent and effective toddler care.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss developmental considerations and age-specific care of the toddler.&nbsp;</li>\r\n    <li>Identify the physiologic and developmental characteristics of the toddler.&nbsp;</li>\r\n    <li>Describe the toddler's age-specific needs and incorporate them into practice.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E17BD0AF-7823-E811-BEE8-005056B1633E",
                "course_version": 4,
                "name": "PLS - EPACO: Age-Specific Care for Adults",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development of adult patients. For the purposes of this course, \u201cadult\u201d is defined as patients ages 19 and older. By understanding and incorporating the physical, cognitive and psychosocial needs of adult patients and their families into daily practice, the health care team will be more effective in providing competent care to this patient population.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify expected developmental and physiological characteristics of the adult patient across physical, cognitive, emotional and social domains.</li>\r\n    <li>Apply age-specific developmental and psychological principles to assessment, communication and daily clinical care of the adult patient.</li>\r\n    <li>Recognize the age appropriate needs of the adult patient to support safe, family-centered and developmentally appropriate care.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "1B3FDD1B-8723-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Child Abuse and Neglect",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Sensitive Content Warning\r\n\r\nThis course addresses sensitive topics associated with child maltreatment, including physical abuse, sexual abuse, human trafficking, psychological maltreatment, medical child abuse and neglect. Some content may be distressing or triggering for learners. Please take care of your emotional well-being while engaging with this material. Child abuse is a serious threat to the health, safety and well-being of children in this country. It is a sensitive issue that requires careful assessment by health care providers. This course covers the types of child abuse and neglect, including human trafficking, as well as the related indicators and the reporting responsibilities of health care providers.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CME Non-Physician (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe the primary categories of child maltreatment(neglect, physical abuse, sexual abuse, human trafficking, psychological maltreatment, and medical child abuse).</li>\r\n    <li>Recognize key risk factors and protective factors associated with child abuse and neglect.</li>\r\n    <li>Identify indicators of child maltreatment, including indicators associated with human trafficking.</li>\r\n    <li>Differentiate cultural health practices and medical conditions from signs of child abuse or neglect during child maltreatment assessments.</li>\r\n    <li>Describe key components of the evaluation and care management process for children with suspected abuse.</li>\r\n    <li>Determine mandated reporters and describe their legal responsibilities for reporting suspected child maltreatment.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "DBD416CA-8723-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Preventing Pediatric Falls",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The Centers for Medicare and Medicaid(CMS2025)defines a patient fall as any sudden, unintentional descent\u2014whether or not injury occurs\u2014that results in the patient coming to rest on the floor, another surface, another person, or an object. To reduce falls, each hospital must implement a fall reduction program that includes individualized strategies for every patient. Staff, patients, and caregivers should all receive education on how to prevent falls.\r\n\r\nThis course aligns with the fall prevention elements outlined in the Children\u2019s Hospitals Solutions for Patient Safety(SPS)Prevention Bundles.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Summarize fall risk factors in pediatric patients across developmental stages.&nbsp;</li>\r\n    <li>Outline assessment parameters for fall risk based on screening using a validated assessment tool.&nbsp;</li>\r\n    <li>Implement pediatric fall prevention interventions recommended by national safety and quality organizations.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6E1DE5DE-8C23-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Management of Peripheral IV Complications in the Pediatric Patient",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Peripheral intravenous lines(PIVs)play an important role in the treatment of many clinical conditions in pediatric patients. However, PIVs are associated with potential complications. This course provides an overview of PIV assessment and management, including recognition of abnormal assessment findings, identification of common PIV complications, and strategies for prevention and management. Prompt recognition of complications and timely, appropriate interventions are essential to help reduce the risk of adverse patient outcomes.     \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify PIV assessment findings that may indicate a complication.</li>\r\n    <li>Recognize appropriate interventions and follow-up actions used in the management of PIV complications.</li>\r\n    <li>Discuss guidelines for preventing PIV complications.</li>\r\n    <li>Describe documentation expectations related to PIV assessment, including the use of evidence-based assessment scales.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B716E8A2-9123-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Medication Error Reduction",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Various studies have found that delivering a single dose of medicine requires between 10 and 15 steps, making the medication delivery process prone to error. This course discusses the incidence of medication errors, reviews current regulatory standards, and identifies prevention strategies used to support a culture of high reliability and reduce errors.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify phases of the medication administration process where pediatric patients are at increased risk of harm from medication errors.&nbsp;</li>\r\n    <li>Analyze common sources, types, and contributing factors of medication errors across the medication-use continuum.</li>\r\n    <li>Demonstrate the importance of timely identification, documentation, and reporting of medication errors and near misses to support organizational learning and patient safety.</li>\r\n    <li>Evaluate evidence-based strategies to prevent and reduce medication errors, promoting a culture of safety, high reliability, and continuous quality improvement.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.5 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "DCD4A9D2-9123-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pain Management: Pain Pathophysiology",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Pain affects most pediatric patients at some point in their care. For the health care team, understanding pain pathophysiology is essential to accurately identifying and treating pain. This course provides an overview of pain types and their underlying pathophysiology and examines how pain management techniques integrate an understanding of both.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Differentiate between acute and chronic pain.</li>\r\n    <li>Recognize the pathophysiology of how the body senses and processes pain.&nbsp;</li>\r\n    <li>Describe the classifications of nociceptive pain and the key characteristics of neuropathic pain.&nbsp;</li>\r\n    <li>Explain the various pharmacologic and non-pharmacologic methods for treating pain based on pain pathophysiology.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.5 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E721EAE8-9123-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pain Management: Pharmacological Management of Pediatric Pain",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course discusses the pharmacological management of pain in children. You will review analgesic medications and their role in achieving adequate pain control.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define key pharmacology concepts associated with pain control.</li>\r\n    <li>State the indications, mechanism of action and the most common adverse effects of non-opioids, opioids and adjuvants for pain management.</li>\r\n    <li>Differentiate between tolerance, dependence, withdrawal and addiction.</li>\r\n    <li>Recognize the importance of anticipatory guidance for families with children receiving opioid pain medication.</li>\r\n    <li>Describe how to safely dispose of opioid medications.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "AD59C428-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Assessment: The Gastrointestinal System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Health care providers must develop exceptional assessment skills in a gastrointestinal(GI)physical exam. GI symptoms can be extremely subjective due to variations in definitions of symptoms such as diarrhea and constipation. This course describes the skills and knowledge required to perform a comprehensive pediatric GI history and physical assessment, as well as the ability to determine normal and abnormal findings.   \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the components of a gastrointestinal(GI)history specific to the pediatric patient.&nbsp;</li>\r\n    <li>Discuss age and development-appropriate components of the pediatric GI and nutritional assessment and physical exam.</li>\r\n    <li>Describe normal and abnormal findings of the pediatric GI physical exam.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6F700D9F-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Nutritional Overview",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Nutrition is a critical component of pediatric well-being at all stages of development and may be affected by both acute and chronic illness.\r\n\r\nA child\u2019s nutritional status can impact recovery time and overall health outcomes. Clinicians can improve outcomes by assessing and supporting optimal nutrition during a child\u2019s hospital stay.\r\n\r\nThis course will discuss the specific nutritional needs of the following pediatric age groups: Infants, Toddlers, Preschoolers, School-Age, and Adolescents. \r\n\r\nA registered dietitian should be consulted for advanced nutrition care, including specialized medical nutrition therapy, comprehensive nutrition assessments, evaluation of growth trends, and determination of individualized calorie, protein and fluid need.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Determine how to assess adequate nutrition status using age-specific energy, protein and fluid needs.&nbsp;</li>\r\n    <li>Describe age-appropriate nutrition needs and developmental implications on food choices.&nbsp;</li>\r\n    <li>Identify behavioral and lifestyle interventions for childhood obesity.&nbsp;</li>\r\n    <li>Identify risk factors and screening methods for malnutrition in the pediatric patient.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D51F3BB1-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Peripheral IV Care & Management",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The peripheral intravenous catheter, or PIV, is the most commonly used intravenous device in hospitalized patients. This course provides an overview of PIV care and introduces methods to optimize PIV care and maintenance, with a focus on preventing infiltration and maintaining PIV access throughout the intended duration of therapy. The course covers comfort measures, device selection, insertion and securement techniques, and assessment parameters. Although PIVs are considered low risk, complications can occur and may result in serious harm. Clinicians should follow the standard of care to protect patients from potential complications.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify comfort and pain-management strategies appropriate for pediatric patients undergoing PIV insertion.&nbsp;</li>\r\n    <li>Select the appropriate vascular access device and insertion site based on patient history, developmental factors, therapy duration, and the type of fluids or medications prescribed.&nbsp;</li>\r\n    <li>Describe correct PIV insertion techniques to reduce risks for complications, including infiltration and extravasation.&nbsp;</li>\r\n    <li>Identify PIV securement techniques that promote visualization and stabilization of site.&nbsp;<br />\r\n    Outline assessment parameters used when monitoring PIV sites.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "27CFF6E1-9223-E811-AAA9-005056B1689B",
                "course_version": 5,
                "name": "PLS - EPACO: Pressure Injury Staging Assessment",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This assessment provides staff members the opportunity to practice and verify accuracy in identifying pressure injury stages. Enhanced competency in accurately staging pressure injuries will assist in providing appropriate management strategies. Each test question will include a photograph and description of a pressure injury. Stage each pressure injury in accordance with the National Pressure Injury Advisory Panel\u2019s(NPIAP)staging guidelines.\r\n\r\nAdditional Courses \r\n\r\nAdditional Pediatric Learning Solutions courses* you may find helpful:\r\n- Pediatric Assessment: The Integumentary System\r\n- Introduction to Pediatric Pressure Injury\r\n- Pressure Injuries in the Pediatric Population: Staging and Care\r\n \r\n\r\n*Note: This course may not be currently available in your organization.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Accurately stage pressure injury images using the 2025 NPIAP staging guidelines.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C83FB982-8723-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Intimate Partner Violence",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Sensitive Content Warning \r\n\r\nThis course addresses sensitive topics associated with intimate partner violence, including intimate partner violence, child abuse and neglect, and human trafficking. Some content may be distressing or triggering for learners. Please take care of your emotional well-being while engaging with this material.\r\n\r\nIntimate partner violence (IPV) is a serious, widespread public health issue. All health care providers, including those working in pediatric settings, must be sensitive to this issue and should routinely and carefully assess patients and family members for signs of violence.\r\n\r\nThis course explores the prevalence of IPV, types and indicators of abuse, the impact on children and the related responsibilities of health care providers.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CME Non-Physician (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define intimate partner violence.</li>\r\n    <li>Explain key elements, signs and symptoms and types of intimate partner violence.</li>\r\n    <li>Identify signs of teen dating violence, including risk factors, forms of abuse and potential short- and long-term effects on youth.</li>\r\n    <li>Describe the impact of intimate partner violence on children.</li>\r\n    <li>Outline health care provider responsibilities related to screening, intervention, documentation and reporting of intimate partner violence.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "65502398-8723-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Introduction to Ethics",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Navigating ethical issues in clinical settings is challenging, particularly in pediatric acute care facilities. Differing values among stakeholders, along with rapid technological advances, can make it difficult to determine what is right or wrong for an individual patient. This course will examine moral dilemmas, provide tools to analyze and work through complex cases, and cover resources available to clinicians.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CME Non-Physician (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe situations in pediatric facilities that may create ethical issues.&nbsp;</li>\r\n    <li>Discuss core ethical values that may influence medical decision making.&nbsp;</li>\r\n    <li>Apply ethical decision-making frameworks.&nbsp;</li>\r\n    <li>Recognize situations that might require other resources, such as an ethics consultation.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "1F8862AD-8723-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Restraints and Seclusion",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The use of restraint and seclusion may be necessary to maintain the safety of pediatric patients and health care staff. Because these interventions carry potential risks, clinicians must understand the guidelines, safeguards and required practices that govern their use. This course reviews regulatory standards and practice guidelines related to restraint and seclusion in the hospital setting, including those from: \r\n\r\n- Centers for Medicare & Medicaid Services(CMS)\r\n- The Joint Commission(TJC)\r\n- National Integrated Accreditation for Healthcare Organizations(NIAHO; aka DNV)\r\n\r\nState laws and regulations may establish additional requirements. Together, these standards are designed to protect patients, reduce harm and promote safe, appropriate care. Always follow your organization\u2019s policies.\r\nCMS establishes federal requirements for restraint and seclusion, and accrediting organizations, such as TJC and NIAHO, evaluate compliance with those requirements. Organizations may adopt more restrictive standards and training requirements based on the care setting. When requirements differ, follow the most restrictive standard. \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CME Non-Physician (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define restraint and seclusion in the hospital setting and distinguish them from interventions that do not meet the definition of restraint or seclusion.</li>\r\n    <li>Differentiate the indications, clinical purpose and standards of practice for each type of restraint and for seclusion in pediatric patients.</li>\r\n    <li>Describe the regulatory and accreditation requirements governing restraint and seclusion use, including standards from the Centers for Medicare &amp; Medicaid Services (CMS), The Joint Commission (TJC)and National Integrated Accreditation for Healthcare Organizations (NIAHO).&nbsp;</li>\r\n    <li>Identify evidence-based alternatives to restraint and seclusion that promote patient safety and minimize harm in pediatric care settings.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F18CF3B0-8C23-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Health Care Advance Directives: Communicating Wishes",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Advance directives are legal documents that adult patients use to convey their wishes about end-of-life care if they should become unable to communicate or make decisions for themselves. When a patient has completed a health care advance directive, health care providers are legally obligated to obtain a copy of the document and adhere to the patient\u2019s stated wishes. What will you learn in this course?\r\n\r\nThis course reviews\r\n- Type of advance directives\r\n - Advance care planning options for minor patients\r\n - Responsibility of health care providers\r\n - Potential problems encountered when working with a patient with an advance directive\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.50] [CME Non-Physician (JAICE) Credits: 0.50] [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe the purpose and importance of an advance directive.</li>\r\n    <li>Compare and contrast types of advance directives.&nbsp;</li>\r\n    <li>Discuss advance care planning options for minor patients.&nbsp;</li>\r\n    <li>Outline health care providers&rsquo; responsibilities related to advance directives.&nbsp;</li>\r\n    <li>Identify common problems encountered when following an advance directive.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3928DEC6-8C23-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: High-Alert Medications",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of high-alert medications, including the definition of \u201chigh-alert\u201d and specific high-alert medications. Common risk factors and strategies to prevent harm and reduce medication errors are also discussed.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define high-alert medications.&nbsp;</li>\r\n    <li>Discuss the high-alert medications identified by the Institute for Safe Medication Practices(ISMP).&nbsp;</li>\r\n    <li>Recognize common risk factors and suggested strategies to reduce errors related to high-alert medications.&nbsp;</li>\r\n    <li>Identify &ldquo;just culture&rdquo; behaviors relative to the administration of high-alert medications and patient safety.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "5F982DD5-8C23-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Introduction to Pediatric Pressure Injury",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Though most pressure injury research involves the adult population, pressure injuries also affect infants and children. It is important for all members of the health care team to understand the factors involved in pressure injury development and how to prevent them in at-risk neonatal and pediatric patients. This course includes a review of normal skin anatomy and introduces the risk factors and risk assessment for pressure injury development in the pediatric population, as well as related prevention strategies. The content of this course aligns with the Children\u2019s Hospitals\u2019 Solutions for Patient Safety(SPS) prevention and maintenance bundles.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the characteristics for each stage and category of pressure injury, including accurate recognition of a Stage 1 pressure injury.</li>\r\n    <li>Recognize common locations and medical devices associated with pressure injury development.</li>\r\n    <li>Use a risk-assessment tool such as the Braden QD scale to assess risk factors of developing a pressure injury.</li>\r\n    <li>Implement intervention strategies to reduce risk of pressure injury development.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D7722A0A-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Assessment: Performing a Head-to-Toe Assessment",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "A systematic head-to-toe assessment, based on the patient\u2019s age, supports a thorough and efficient exam. If a patient shows physical signs or reports problems with a specific body system, a more thorough assessment should be performed.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Outline the developmental approach to a pediatric head-to-toe assessment.</li>\r\n    <li>Identify normal vital sign values and growth parameters and recognize abnormal findings that require immediate intervention.</li>\r\n    <li>Describe the detail and sequence of a head-to-toe assessment based on the child&rsquo;s age and developmental level.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "096E213D-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Assessment: The Genitourinary System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Assessment of the genitourinary system provides valuable information about a patient\u2019s health. However, families and patients, especially adolescents, may be uncomfortable discussing genitourinary symptoms. Health care providers must be competent and sensitive in obtaining a complete history and performing a thorough genitourinary assessment. \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate a focused review of current genitourinary symptoms as well as medical and family history while maintaining sensitivity and privacy.</li>\r\n    <li>Summarize and implement the essential components of a genitourinary assessment in pediatric patients.</li>\r\n    <li>Describe normal and abnormal findings of the pediatric genitourinary exam.</li>\r\n    <li>Assess physical and behavioral symptoms, using sensitivity and privacy, to address sexual health concerns for pediatric patients.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E797454F-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Assessment: The Integumentary System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The integumentary system consists of the skin, hair, nails, glands and nerves. Its main function is to serve as a barrier that protects the body from the outside world, including chemicals, ultraviolet rays, and microbes. It also functions to retain body fluids, eliminate waste products, and regulate temperature.\r\n\r\nThis course reviews the assessment skills necessary to identify abnormalities of the integumentary system in children. There is a wide variation in the presentation and treatment of conditions. Therefore, accurate assessment, including a detailed history and physical examination, is extremely important.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.25]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe a complete skin assessment and necessary documentation for the pediatric patient.</li>\r\n    <li>Identify normal and frequently seen abnormal findings in the pediatric integumentary exam.</li>\r\n    <li>Discuss presentation of common disorders of the pediatric integumentary system.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1.25 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "1F364574-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Assessment: The Neurological System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Neurological dysfunction can affect nearly any body system and may be difficult to diagnose, especially in infants. A thorough neurological assessment supports accurate diagnosis and treatment of neurological disease or injury.\r\n\r\nThis course reviews the key components of a systematic pediatric neurological exam and outlines specific assessment guidelines for suspected brain injury.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the components of the neurological system assessment specific to the pediatric patient.</li>\r\n    <li>Describe normal and abnormal findings of the pediatric neurological exam.&nbsp;</li>\r\n    <li>Identify associated findings of a patient with suspected brain injury.&nbsp;</li>\r\n    <li>Summarize the components of a focused neurological assessment, including the Glasgow Coma Scale, used to help detect brain injury and monitor its progression.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "93959AC5-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pressure Injuries in the Pediatric Population: Staging and Care",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Pressure injuries do occur in the pediatric population. Pressure injuries can cause considerable harm and may result in increased length of stay, infection, surgical intervention and sepsis. It is imperative that health care providers know how to accurately assess and treat pressure injuries and be able to provide appropriate wound care management to prevent further injury. The course provides an overview of pressure injury assessment and staging based on the revised National Pressure Injury Advisory Panel (NPIAP) system, including distinctions between pressure injuries and other wound types and approaches to wound care management.\r\n\r\nAdditionally, CHA has aligned this content with the Children\u2019s Hospitals\u2019 Solutions for Patient Safety (SPS) Prevention Bundle to ensure it represents current evidence-based practice. \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Differentiate pressure injury stages and identify unstageable, deep tissue, and mucosal membrane pressure injuries in accordance with National Pressure Injury Advisory Panel (NPIAP) standards.</li>\r\n    <li>Discuss the elements required to thoroughly document pressure injuries.</li>\r\n    <li>Differentiate pressure injuries from other wound types.</li>\r\n    <li>Describe key interventions when caring for and managing pressure injuries.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4117D5C3-9123-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pain Management: Non-Pharmacological Therapies in the Management of Pediatric Pain",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Non-pharmacological therapies, used in conjunction with pharmacological interventions, can help manage children\u2019s pain. This course provides an overview of non-pharmacologic approaches to pediatric pain management, including developmentally appropriate strategies.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Explain the pain pathway and the role non-pharmacological therapies can have in disrupting that pathway.</li>\r\n    <li>Illustrate the importance of caregiver presence, preparation and positioning for comfort as strategies for pain management.</li>\r\n    <li>Describe developmentally appropriate, non-pharmacological pain management strategies within the sensory, cognitive/behavioral, and imagery categories.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "A3104A1A-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Assessment: The Cardiovascular System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course reviews the key components of a cardiovascular(CV)assessment in children. Although most children have healthy hearts, cardiac conditions in pediatric patients can be subtle and remain undetected for some time. Therefore, completing a routine, systematic cardiovascular assessment is essential. A thorough CV assessment also can help identify early risk factors for cardiovascular disease later in life.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Outline the components of the cardiovascular history and physical exam of the pediatric patient.</li>\r\n    <li>Identify normal and abnormal findings of the cardiovascular assessment.</li>\r\n    <li>Develop a systematic approach to assessing heart sounds and differentiating murmurs that may be associated with cardiac defects.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4BA7F15F-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Assessment: The Musculoskeletal System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Early detection and treatment of musculoskeletal disorders and skeletal deformities can prolong function and prevent complications. This course discusses the assessment skills necessary to identify abnormalities in a pediatric musculoskeletal exam.   \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify components of the musculoskeletal system history specific to the pediatric patient.</li>\r\n    <li>Describe normal and abnormal findings of the pediatric musculoskeletal exam and associated conditions.</li>\r\n    <li>Identify essentials of the post-surgical orthopedic assessment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "8161C1DD-8723-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Therapeutic Relationships and Professional Behavior",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The National Council of State Boards of Nursing (2024) states that a \u201ctherapeutic nurse-patient relationship protects the patient\u2019s dignity, autonomy and privacy and allows for the development of trust and respect.\u201d The complexity of the health care environment can make it challenging to establish therapeutic relationships with pediatric patients and their families.\r\n\r\nThis module will identify the characteristics of a professional, therapeutic clinician-patient relationship as well as strategies for recognizing and avoiding inappropriate behaviors and relationships. \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CME Non-Physician (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe therapeutic relationships between health care providers and those under their care, including the phases of relationship development.&nbsp;</li>\r\n    <li>Discuss the continuum of professional behavior and the consequences of boundary crossings and boundary violations, including appropriate responses.&nbsp;</li>\r\n    <li>Recall the professional obligations required of health care professionals when participating in social media networking.&nbsp;</li>\r\n    <li>Identify behaviors with patients and families that reflect the concepts of therapeutic relationships, boundary crossings and boundary violations.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "38BA9C8E-8C23-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Clinical Delegation",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Clinical delegation is a critical component of the health care team\u2019s collaborative effort to provide quality patient care. Assistive personnel are integral to the health care team for many reasons. With changes to health care, such as organizational cost-containment strategies, vacant positions, high patient census, increased patient acuity and demographic changes, nurses and assistive personnel must adapt roles and workflows to ensure safe, efficient, and patient-centered care. This course will help clinicians develop the delegation skills necessary to coordinate and deliver safe, efficient patient care within a health care team that includes assistive personnel.  \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define clinical delegation.</li>\r\n    <li>Describe the importance of appropriate clinical delegation.</li>\r\n    <li>Discuss roles and responsibilities related to clinical delegation.</li>\r\n    <li>Identify strategies to overcome barriers to delegation.</li>\r\n    <li>Discuss the five rights of delegation.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FD7DCDB1-9123-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pain Management: Assessment of Pain",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Evidence-based pain interventions can significantly reduce patient distress, improve the patient experience, and help guide care. Pain assessment is the foundation of effective pain management. This course reviews the elements of a complete pain assessment, pain-intensity scales, and the role of clinical judgment in effectively managing patient pain.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss pain and key elements of a comprehensive pain assessment.&nbsp;</li>\r\n    <li>Delineate accreditation standards for pain assessment and management.</li>\r\n    <li>Describe the pain intensity scales commonly used in assessing children of various levels of development and function.</li>\r\n    <li>Discuss the role of critical judgment in assessing and managing pain.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FDE887F9-9123-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pain Technologies: PCA & Epidural Analgesia",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course covers the safe and effective use of patient-controlled analgesia(PCA) and epidural analgesia in pediatric pain management. Topics include the advantages and disadvantages of each method, patient selection criteria, commonly used medications, assessment and monitoring requirements, and associated nursing interventions. \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>State the advantages and disadvantages of PCA and epidural analgesia.</li>\r\n    <li>Identify patients who are appropriate candidates for PCA or epidural analgesia.</li>\r\n    <li>Discuss medications commonly used for PCA and epidural analgesia.</li>\r\n    <li>Describe appropriate nursing assessments, monitoring, and corresponding nursing interventions, as well as documentation and patient/family education related to PCA and epidural analgesia.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2148338B-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pediatric Assessment: The Respiratory System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Respiratory symptoms are among the most common reasons for outpatient visits and inpatient admissions in pediatrics. The skills required for the pediatric respiratory exam are among the most important when assessing pediatric patients. This course reviews the key components necessary to provide a thorough pediatric respiratory exam.    \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss key elements of a complete history of respiratory illnesses and thorough respiratory assessment.</li>\r\n    <li>Describe clinical manifestations of various respiratory illnesses seen in pediatric patients.</li>\r\n    <li>Recognize important signs and symptoms to document as part of the respiratory system assessment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "BD7EFE29-7923-E811-893D-005056B17124",
                "course_version": 4,
                "name": "PLS - EPACO: Basic Medication Calculation",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Accurate medication calculation is an essential responsibility for all health care practitioners. Their role includes not only performing precise calculations but also verifying the accuracy of those completed by colleagues. Every clinician involved in ordering, dispensing or administering medications must be competent in medication calculation. This course offers a review of fundamental skills, including measurement, conversions and dosage calculations.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify frequent causes of common medication errors or medication calculation errors.</li>\r\n    <li>Apply strategies that support safe medication administration.</li>\r\n    <li>Review standard measurement conversions and accurately convert basic values between different weight and measurement systems.</li>\r\n    <li>Demonstrate accurate dosage calculations using appropriate methods and pediatric-specific rounding guidelines.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1.0 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];